import 'css-chunksrc/client/scenes/preferences/dateFormatForm/styles.scss';export default {};